/* eslint-disable max-lines */
import {
  AlarmGroupsIcon,
  AuditLogIcon,
  CameraLiveViewIcon,
  DoorGrpIcon,
  DoorsIcon,
  InsightsIcon,
  LocationIcon,
  ScanIcon,
  UnifiedMonitoringIcon,
  UserIcon,
} from '@hakimo-ui/hakimo/ui-elements';
import { NavItem } from '@hakimo-ui/hakimo/ui-navigation';
import {
  ArrowsPointingInIcon,
  BellAlertIcon,
  BoltIcon,
  DocumentTextIcon,
  MagnifyingGlassIcon,
  SpeakerWaveIcon,
  VideoCameraIcon,
} from '@heroicons/react/24/outline';

export const navItems: NavItem[] = [
  // {
  //   id: 'monitoring',
  //   name: 'Monitoring',
  //   href: '/monitoring',
  //   icon: DesktopFrameIcon,
  //   requiredPermissions: [
  //     'location_alarms/monitoring:count',
  //     'location_alarms/monitoring:get_pending',
  //   ],
  // },
  {
    id: 'unified-monitoring',
    name: 'Monitoring',
    href: '/unified-monitoring',
    icon: UnifiedMonitoringIcon,
    requiredPermissions: ['unified_monitoring:view'],
  },
  {
    id: 'location-alarms',
    name: 'Location Alarms',
    href: '/location-alarms',
    icon: ArrowsPointingInIcon,
    requiredPermissions: ['location_alarm:view'],
  },
  {
    id: 'alarms',
    name: 'Alarms',
    href: '/alarms',
    icon: BellAlertIcon,
    requiredPermissions: ['alarm:view'],
  },
  {
    id: 'locations',
    name: 'Locations',
    href: '/locations',
    icon: LocationIcon,
    requiredPermissions: ['location:view'],
  },
  {
    id: 'cameras',
    name: 'Cameras',
    href: '/cameras',
    icon: VideoCameraIcon,
    requiredPermissions: ['camera:view'],
  },
  {
    id: 'live-views',
    name: 'Live Views',
    href: '/live-views',
    icon: CameraLiveViewIcon,
    requiredPermissions: ['camera:view'],
  },
  {
    id: 'location-incidents',
    name: 'Reports',
    href: '/location-incidents',
    icon: DocumentTextIcon,
    requiredPermissions: ['location_incidents:view'],
  },
  {
    id: 'insights',
    name: 'Insights',
    href: '/insights',
    icon: InsightsIcon,
    requiredPermissions: ['insights:view'],
  },
  {
    id: 'forensics',
    name: 'Forensics',
    href: '/forensics',
    icon: MagnifyingGlassIcon,
    requiredPermissions: ['forensics:view'],
  },
  {
    id: 'alarm-groups',
    name: 'Alarm Groups',
    href: '/alarm-groups',
    icon: AlarmGroupsIcon,
    requiredPermissions: ['alarm_group:view'],
  },
  {
    id: 'users',
    name: 'Users',
    href: '/users',
    icon: UserIcon,
    requiredPermissions: ['user:view'],
  },
  {
    id: 'auditLog',
    name: 'Audit Log',
    href: '/audit-log',
    icon: AuditLogIcon,
    requiredPermissions: ['audit-log:view'],
  },
  {
    id: 'audiodevices',
    name: 'Audio Devices',
    href: '/audiodevices',
    icon: SpeakerWaveIcon,
    requiredPermissions: ['audio_devices:view'],
  },
  {
    id: 'doors',
    name: 'Doors',
    href: '/doors',
    icon: DoorsIcon,
    requiredPermissions: ['door:view'],
  },
  {
    id: 'door_groups',
    name: 'Door Groups',
    href: '/doorgroups',
    icon: DoorGrpIcon,
    requiredPermissions: ['door_group:view'],
  },
  {
    id: 'alarm_type_groups',
    name: 'Alarm Type Groups',
    href: '/alarm-type-groups',
    icon: AlarmGroupsIcon,
    requiredPermissions: ['alarmtype_group:view'],
  },
  {
    id: 'scan',
    name: 'Scan',
    href: '/scan',
    icon: ScanIcon,
    requiredPermissions: ['scan:view'],
  },
  {
    id: 'scan',
    name: 'Scan Escalations',
    href: '/scan-escalations',
    icon: BoltIcon,
    requiredPermissions: ['scan-escalation:view'],
  },
];
